import { z } from 'zod';
// The glance (ADR-074 §1) — what a tab's short poll receives. Everything a
// running screen must be able to retune from the server rides here, because a
// value baked into the frontend would be frozen inside tabs that stay open for
// weeks. SMALL by rule (§8): the whole answer stays under 512 bytes — a test
// holds it.
/** The change tokens the viewer may receive, by name. A DICTIONARY on purpose:
 *  a client compares the names it knows and ignores the rest, so a new name (a
 *  per-user token) never breaks a tab opened before it existed. A token is
 *  opaque — compared for EQUALITY only, never ordered, never counted. */
export const ChangeTokensSchema = z.record(z.string().min(1).max(32), z.string().min(1).max(64));
export const GlanceResponseSchema = z
    .object({
    tokens: ChangeTokensSchema,
    /** When to glance again — the server's rhythm, in seconds. */
    rhythm_s: z.number().int().positive(),
    /** Every live question is re-read in full this often, whatever the tokens say — in seconds. */
    resync_s: z.number().int().positive(),
    /** After this much silence a screen says it cannot refresh — in seconds. */
    stale_after_s: z
        .object({
        /** Always-on screens. */
        always_on: z.number().int().positive(),
        /** Ordinary pages. */
        page: z.number().int().positive(),
    })
        .strict(),
    /** The server's clock (ISO 8601) — ages are computed from it, so a wrong local clock cannot lie. */
    server_time: z.string().datetime(),
    /** The running server's version — a tab on an older one may reload itself. */
    version: z.string().min(1).max(64),
})
    .strict();
